import React from "react";
import { useSelector } from "react-redux";
import Helmet from "react-helmet";
import { helmetJsonLdProp } from "react-schemaorg";
import { useLocation } from "react-router-dom";

import { useAppSelector } from "@/redux/store";
import { getSEOStructuredProduct } from "@/util/seo";
import { selectProductDetails } from "../selectors";
import { useCurrency } from "@/hooks";
import { selectCdnImageSettings } from "@/util/selectors";

const PDPHelmet = () => {
  const meta = useAppSelector(state => state.seo.meta);
  const configCdnImagesSettings = useSelector(selectCdnImageSettings);
  const productDetails = useSelector(selectProductDetails);
  const currencyCode = useCurrency();
  const location = useLocation();
  const baseImageUrl =
    configCdnImagesSettings?.mainImageUrl ||
    configCdnImagesSettings?.main ||
    "";

  const isIndexable =
    typeof meta?.isIndexable === "boolean" ? meta.isIndexable : true;
  if (!isIndexable) return null;

  const seoStructuredProductData = getSEOStructuredProduct(
    productDetails,
    location,
    currencyCode,
    baseImageUrl
  );

  return (
    <Helmet script={[helmetJsonLdProp(seoStructuredProductData as any)]} />
  );
};

export default PDPHelmet;
